import React from "react";
import "./quote.css";

export default () => {
  return (
    <blockquote className="quote">
      <div>
        As a web application developer, I create elegant and eye-catching
        interfaces with a focus on simplicity and accessibility that allows for
        an incredible user experience
      </div>
    </blockquote>
  );
};
